__turbopack_context__.v({
  "grid2Columns": "tweet-media-module__Y5TNEq__grid2Columns",
  "grid2x2": "tweet-media-module__Y5TNEq__grid2x2",
  "grid3": "tweet-media-module__Y5TNEq__grid3",
  "image": "tweet-media-module__Y5TNEq__image",
  "mediaContainer": "tweet-media-module__Y5TNEq__mediaContainer",
  "mediaLink": "tweet-media-module__Y5TNEq__mediaLink",
  "mediaWrapper": "tweet-media-module__Y5TNEq__mediaWrapper",
  "root": "tweet-media-module__Y5TNEq__root",
  "rounded": "tweet-media-module__Y5TNEq__rounded",
  "skeleton": "tweet-media-module__Y5TNEq__skeleton",
});
